import React, { ChangeEvent, useState, useEffect } from 'react'
import { AsyncSelect as Select } from '@rockr/rock-ui'
import { mountEvent } from '../../shared/helpers/input'

function filterByLabel(list: { label: string }[], input: string) {
  return list.filter(({ label }) => {
    return label.toLowerCase().includes(input.toLowerCase())
  })
}

type Option = {
  label: string
  value: string | number
}

type Props = {
  options: Option[]
  name: string
  onChange?: (e: ChangeEvent<any>) => any
  defaultValue?: Option
  value?: string | number
  isDisabled?: boolean
  isInvalid?: boolean
}

export const Autocomplete: React.FC<Props> = ({
  options,
  name,
  onChange,
  defaultValue,
  value,
  isDisabled,
  isInvalid
}) => {
  const [selected, setSelected] = useState<Option | null>()
  const loadOptionsSelect = (input: string, callback: any) => {
    return callback(filterByLabel(options, input))
  }

  // workaround to use with formik
  const handleChange = (params: {
    label: string
    value: string | number
  }) => {
    const { value } = params
    const event = mountEvent(name, value)

    onChange?.(event as ChangeEvent<any>)
  }

  useEffect(() => {
    const selected = options.find(option => option.value === value)
    setSelected(selected || null)
  }, [value, options])

  return (
    <Select
      name={name}
      value={selected}
      defaultValue={defaultValue}
      onChange={handleChange}
      cacheOptions
      isSearchable
      defaultOptions={options}
      loadOptions={loadOptionsSelect}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
    />
  )
}
